export default function SearchBar({onSearchtextChange}) {
  
  return (
    <div className="">
      <form>
        <input className="search-input" type="text" placeholder="Поиск" onChange={(e) => onSearchtextChange(e.target.value)}/>
      </form>
    </div>
  );
}